import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 230px;
  height: 135px;
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  box-shadow: 0 10px 18px var(--color-shadow);
  border-radius: 10px;
  position: relative;
  display: flex;
  flex-direction: column;

  .title {
    color: var(--color-text-muted);
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%;
    text-transform: capitalize;
  }

  .content {
    padding: 20px 20px 4px;
  }

  .description {
    padding: 0 20px;

    .balance {
      color: var(--color-link);
      font-size: 18px;
      font-style: normal;
      font-weight: 600;
      line-height: 150%; /* 27px */
    }
  }

  .buttonContainer {
    height: 40px;
    width: calc(100% - 40px);
    margin: 0 20px;
    display: block;
    bottom: 0;
    position: absolute;
    border-top: 1px solid var(--color-border);

    button {
      border-radius: 10px;
      padding: 0;
      height: 36px;
      width: 100%;
    }
  }

  .dots-button {
    position: absolute;
    top: 20px;
    right: 10px;
    cursor: pointer;

    :hover {
      & svg {
        circle {
          fill: var(--color-link);
        }
      }
    }
  }
`;
